import { makeStyles } from 'tss-react/mui'


const useStyles = makeStyles()((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'left',
        color: theme.palette.grey[600],
        padding: 0,
        width: '60%',
        textTransform: 'capitalize',
        justifyContent: 'left'
    },
    value: {
        lineHeight: '20px'
    },
    compact: {
        alignItems: 'center'
    }
}))

export default useStyles